module.exports = __webpack_public_path__ + "static/media/mail-ico.1d552e74.svg";